/* eslint-disable no-useless-escape */
/* eslint-disable quotes */
const preferredCodecs = [
  "video/webm\;codecs=h264",
  "video/webm\;codecs=vp9",
  "video/webm\;codecs:vp9", // for firefox
  "video/webm\;codecs=vp8",
  "video/webm",
  "video/mpeg"
];

export function getPreferredVideoCodec() {
  for (const codec of preferredCodecs) {
    if (MediaRecorder.isTypeSupported(codec)) {
      return codec;
    }
  }
  return undefined;
}
